import {
  IOnlineRegistrationsApiCall,
  IRestApiService,
  PendingClientDataDTO,
  StudioClientsByPhoneResponse,
  VerifyPinResponse,
} from '../types';

class OnlineRegistrationsApiCall implements IOnlineRegistrationsApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  studioClientsByPhone(studioId: string, phone: string, groupId: string): Promise<StudioClientsByPhoneResponse> {
    return this.restApiService.post(`online-registrations/studio-clients`, {
      studioId,
      phone,
      groupId,
    });
  }

  verifyPin(studioId: string, phone: string, pin: string): Promise<VerifyPinResponse> {
    return this.restApiService.post(`online-registrations/verify-pin`, {
      studioId,
      phone,
      pin,
    });
  }

  verifyPinByToken(pin: string, token: string): Promise<VerifyPinResponse> {
    return this.restApiService.post(`online-registrations/verify-pin-by-token`, {
      token,
      pin,
    });
  }

  addPendingClient(body: PendingClientDataDTO): Promise<any> {
    return this.restApiService.post('online-registrations/create-pending-client', body);
  }
}

export default OnlineRegistrationsApiCall;
